module.exports = __webpack_public_path__ + "static/media/CorrugatedImg1.a71692f8.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CorrugatedImg1.JPG
// module id = 1157
// module chunks = 0